

import {useContext, useEffect, useState} from 'react';
import NivelesEstructureContext from 'context/NivelesEstructureContext';
import {
 getAll,
 create,
 update,
 del
} from 'services/NivelesEstructureService.js'
import Swal from 'sweetalert2'


let totalPages;


export function useNivelesEstructure(){
 const [page, setPage] = useState(1);
 const [itemsPerPage, setItemsPerPage] = useState(5)

 const {
  allNivelesEstructure, 
  setAllNivelesEstructure,
  nivelesEstructure, 
  setNivelesEstructure, 
  setMessage, 
  message,
  loading, 
  setLoading} = useContext(NivelesEstructureContext);

 
 const getAllNivelesEstructure = async ({nivel, flujo}) => {
  try{
   const response = await getAll({nivel, flujo});
   setAllNivelesEstructure(response)
   return response
  }catch(err){
   const {data, status} = err.response;
   setMessage({message: data.message, status});
  }
 }

 const getNivelesEstructure = async ({page = 1, limit = itemsPerPage, nivel, flujo}) => {
     setLoading(true);
     setPage(page);
     try{
         const allNivelesEstructure = await getAllNivelesEstructure({nivel, flujo});
         setAllNivelesEstructure(allNivelesEstructure);
         totalPages = Math.ceil(allNivelesEstructure.length / limit);
         const nivelesEstructure = await getAll({page, limit, nivel, flujo});
         setNivelesEstructure(nivelesEstructure);
         setLoading(false);
     }catch(err){
         console.log(err);
         const {data, status} = err.response;
         setMessage({message: data.message, status})
         setLoading(false);
     }
 }

 const deleteNivelEstructure = async ({id}) => {
     Swal.fire({
     title: 'Estás seguro?',
     text: '¡No podrás revertir esto!',
     icon: 'warning',
     showCancelButton: true,
     confirmButtonColor: '#3085d6',
     cancelButtonColor: '#d33',
     confirmButtonText: 'Si, eliminar!',
     cancelButtonText: 'Cancelar'
     }).then((result) => {
     if (result.isConfirmed) {
        (async() => {
            try{
                const {message} = await del({id})
                setMessage({message: '', status: 200})
                
                Swal.fire(
                'Éxito!!!',
                message,
                'success'
                )
                getNivelesEstructure({page})
            }catch(err){
                const {data, status} = err.response
                setMessage({message: data.message, status})
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: data.message,
                })
            }
        })();
    }
    })
 }

 const updateNivelEstructure = async ({nivel, id}) => {
    try{
        const {message} = await update({nivel, id})
        setMessage({message: '', status: 200})
        Swal.fire(
        'Éxito!!!',
        message,
        'success'
        )
        getNivelesEstructure({page})
        return ''
     }catch(err){
        const {data, status} = err.response
        setMessage({message: data.message, status})
        return status
     }
 }

 const createNivelEstructure = async ({nivel}) => {
     try{
        const {message} = await create({nivel})
        setMessage(state => ({...state, message}))
        Swal.fire(
        'Éxito!!!',
        message,
        'success'
        )
        getNivelesEstructure({page})
        return ''
     }catch(err){
        const {data, status} = err.response
        setMessage({message: data.message, status})
        return status
     }
 }

 useEffect(() => {
  getNivelesEstructure({});
  // eslint-disable-next-line
 }, [])

 return {allNivelesEstructure, nivelesEstructure, page, totalPages, status: message.status, loading, deleteNivelEstructure, updateNivelEstructure, createNivelEstructure, getNivelesEstructure, setPage, itemsPerPage, setItemsPerPage}
}